import {filter} from 'fuzzy'
import {Typeahead} from '@/core/components/typeahead'
import {useStore} from '@/core/utils/store'
import {doc} from './doc'

export const TypeaheadStatic = doc(
  ({name, valueStorePath, placeholder, options, compact}) => {
    const store = useStore()
    const [search, setSearch] = store.use(['typeahead-static', name, 'search'], '')
    const [value, setValue] = store.use(valueStorePath, '', {override: false})
    return (
      <Typeahead
        name={name}
        placeholder={placeholder}
        search={search}
        onSearch={setSearch}
        onChooseOption={o => setValue(o?.value)}
        option={!!value && options.find(o => o.value === value)}
        options={
          filter(search, options, {extract: o => o.name}).map(x => x.original)
        }
        compact={compact}
      />
    )
  }
)
